import PeriodType from "@/models/Shared/PeriodType";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class DepositCoolingOffSettings extends BaseProductSettings {
    enabled: boolean = false;
    coolingOffPeriodType: PeriodType = PeriodType.Day;
    coolingOffPeriodValue: number = 7;
}